import react, { createContext } from 'react';

const PageContext = createContext(1);
export default PageContext;